import { type TFunction } from 'i18next';

function sIntMessageReasons(translate: TFunction) {
    return [
        { i: 0, t: translate('common:carView.contact.requestTypes.0'), tGa: 'Anfrage' },
        { i: 20, t: translate('common:carView.contact.requestTypes.20'), et: translate('common:carView.contact.requestTypes.20Short'), tGa: 'Probefahrt' },
        { i: 12, t: translate('common:carView.contact.requestTypes.12'), et: translate('common:carView.contact.requestTypes.12Short'), tGa: 'Rückruf' },
        { i: 10, t: translate('common:carView.contact.requestTypes.10'), et: translate('common:carView.contact.requestTypes.10Short'), tGa: 'Termin' },
    ];
}
export default sIntMessageReasons;
